<template>
    <div class="event-hover" v-bind:style="{top: posy + 'px', left: posx + 'px', display: toggled ? 'inline-block' : 'none'}" v-if="toggled">
        <div class="content">
            <div style="border:1px solid #ccc; border-radius:20px; font-size: 11px; padding: 5px; text-align: center;" v-bind:style="{'background-color' : event.color}" v-for="(event,k) in events" :key="k">
                {{ event.name }}
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        name: 'eventhover',
        components: {
        },
        data(){
            return{
                toggled: false,
                elRelative: null,
                events: [],
                posx: 0,
                posy: 0,
            }
        },
        created () {
        },
        destroyed(){
        },
        methods: {
            Close(){
                if($(window.mouse.element).closest('.event-hover').length > 0) return;
                this.Toggle(false);
            },
            Toggle(val){
                if(val !== undefined || val !== null) {
                    this.toggled = val;
                    return;
                }
                this.toggled = !this.toggled;
            },
            Init(elRelative,events){
                this.toggled = true;
                this.events = events;


                if(elRelative){
                    this.elRelative = elRelative
                    this.Reposition();
                }
            },
            Reposition(){
                var view = this;
                requestAnimationFrame(function(){
                    if(!view.elRelative) return;
                    var box = view.elRelative.getBoundingClientRect();


                    view.posx = box.left + box.width - 100;
                    view.posy = box.top + 20;

                    view.$forceUpdate();
                });
            },
        },
        mounted() {
            $('html').append(this.$el);
        }
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



    .event-hover{
        position:fixed;
        display:inline-block;
        max-height: 520px;
        width: 200px;
        border-radius: 5px;
        display:none;
        z-index: 1000;
        background: white;
        box-shadow: 4px 4px 5px 3px rgba(0,0,0,0.2);
        border: 1px solid #a5a5a5;
        padding: 15px;

        top: 120px;
        left: 78px;
        overflow-y: auto;
    }

     .background {
        position: fixed;
        height: 100vh;
        width: 100vw;
        left: 0;
        right: 0;
        z-index: -1;
        top: 0;
    }

</style>
